import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="right">Положение</StyledTableCell>
            <StyledTableCell align="right">Статус</StyledTableCell>
            <StyledTableCell align="right">Допуск</StyledTableCell>
            <StyledTableCell align="right">Название</StyledTableCell>
            <StyledTableCell align="right">Дисциплина</StyledTableCell>
            <StyledTableCell align="right">Возрастная группа</StyledTableCell>
            <StyledTableCell align="right">Начало соревнований</StyledTableCell>
            <StyledTableCell align="right">Конец соревнований</StyledTableCell>
            <StyledTableCell align="right">Место проведения</StyledTableCell>
            <StyledTableCell align="right">Срок приема заявок</StyledTableCell>
            <StyledTableCell align="right">
              Срок редактирования заявок
            </StyledTableCell>
            <StyledTableCell align="right">Заявка</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell align="right">{row.polog}</StyledTableCell>
              <StyledTableCell align="right">{row.status}</StyledTableCell>
              <StyledTableCell align="right">{row.dopusk}</StyledTableCell>
              <StyledTableCell align="right">{row.name}</StyledTableCell>
              <StyledTableCell align="right">{row.disciplina}</StyledTableCell>
              <StyledTableCell align="right">{row.vozrast}</StyledTableCell>
              <StyledTableCell align="right">{row.start}</StyledTableCell>
              <StyledTableCell align="right">{row.finish}</StyledTableCell>
              <StyledTableCell align="right">{row.place}</StyledTableCell>
              <StyledTableCell align="right">{row.srok}</StyledTableCell>
              <StyledTableCell align="right">{row.srokEdit}</StyledTableCell>
              <StyledTableCell align="right">{row.zayav}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
